import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { getTimelineFilterStrategy } from 'flow-doctor-lib/utils/timelineItemStrategies';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { GET_FLOW_DOCTOR_TIMELINE } from 'flow-doctor-lib/queries/FlowDoctorQueries';
const useTimelineItemsWithFilter = ({
  portalId,
  flowId,
  objectId,
  objectTypeId,
  startTimestamp,
  endTimestamp,
  timelineTypes
}, {
  skip
} = {}) => {
  const {
    data: timelineData,
    loading: timelineLoading,
    error: timelineError
  } = useQuery(GET_FLOW_DOCTOR_TIMELINE, {
    variables: {
      portalId,
      flowId,
      objectId,
      objectTypeId,
      startTimestamp,
      endTimestamp,
      timelineTypes
    },
    skip
  });
  const timelineLogItems = useMemo(() => {
    const timelineItems = timelineData ? timelineData.flowDoctorTimeline.timelineItems : [];

    // Hide timeline items that shouldn't be shown for their respective environment
    return timelineItems.filter(getTimelineFilterStrategy(getIsInternal() ? 'INTERNAL' : 'EXTERNAL'));
  }, [timelineData]);
  return {
    timelineLogItems,
    timelineLoading,
    timelineError
  };
};
export default useTimelineItemsWithFilter;